<template>
  <div v-if="!childCompaniesLoading">
    <v-select
      v-model="childCompany"
      :items="childCompanies"
      :placeholder="$t('navigation.master.placeholder-company')"
      variant="plain"
      hide-details
      density="compact"
      class="custom-select"
      menu-icon="null"
      :append-inner-icon="isMasterDashboard ? 'mdi-chevron-down' : null"
      :disabled="!isMasterDashboard"
    />
  </div>
</template>

<script lang="ts" setup>
import { useQuery } from '@vue/apollo-composable'
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import GET_CHILD_COMPANIES from '@/modules/company/queries/ChildCompanies.gql'
const route = useRoute()
const router = useRouter()

const props = defineProps({
  isMasterView: Boolean,
  isMasterDashboard: Boolean,
})

const { result: childCompaniesResult, loading: childCompaniesLoading } = useQuery(
  GET_CHILD_COMPANIES,
  {},
  {
    enabled: props.isMasterView,
  }
)

const childCompanies = computed(() => {
  const companies =
    childCompaniesResult.value?.childCompanies
      ?.filter((company) => company.name)
      .map((company) => {
        return {
          title: company.name,
          value: company.id,
        }
      }) || []

  companies.unshift({
    title: 'All Companies',
    value: 'all',
  })

  return companies
})

const childCompany = ref<string | null>(route?.params?.id ? route.params.id : 'all')

watch(childCompany, (newVal) => {
  if (newVal) {
    if (newVal === 'all') {
      router.push({ path: '/master/dashboard' })
    } else {
      router.push({ path: `/master/dashboard/${newVal}` })
    }
  }
})
</script>
<style scoped>
.custom-select {
  height: 40px;
}
:deep(.custom-select .v-field),
:deep(.custom-select .v-field) {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: #6e6e6e;
}
:deep(.v-field--disabled) {
  opacity: 1;
}
</style>
